import { ConstOptions } from '../../../common/constants/classes';
import { FeeType } from '../interfaces/fees';
import messages from '../messages/fees';

export const FeeTypeOptions = new ConstOptions([
  { value: FeeType.OneTime, message: messages.feeOneTimeOption },
  { value: FeeType.Regular, message: messages.feeRegularOption },
]);
